import React from "react";
import { Button, ButtonProps } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";

interface OpenProductTabProps extends Omit<ButtonProps, "onClick"> {
  productId?: number;
  itemCode?: string;
  tabToOpen?: string;
  type?: string;
  buttonText?: string;
  icon?: React.ReactNode;
}

/**
 * Reusable component to open product tabs in a new browser tab
 *
 * @param productId - The ID of the product
 * @param itemCode - The code of the product
 * @param tabToOpen - The specific tab to open (default: "info1")
 * @param type - The type of operation (default: "edit")
 * @param buttonText - The text to display on the button
 * @param icon - Custom icon for the button
 * @param props - Additional button props from Mantine Button
 */
const OpenProductTab: React.FC<OpenProductTabProps> = ({
  productId = 0,
  itemCode = "",
  tabToOpen = "info1",
  type = "edit",
  buttonText = "Mở trang tab",
  icon = <IconExternalLink size={18} />,
  ...props
}) => {
  const handleOpenProductInNewTab = () => {
    // Create the product data object
    const productData = {
      id: productId,
      itemCode: itemCode,
      type: type,
      tab: tabToOpen,
      timestamp: new Date().getTime(),
    };

    // Save data to localStorage
    localStorage.setItem("hacom_edit_product", JSON.stringify(productData));

    // Open the product page in a new tab
    const baseUrl = window.location.origin + "/product-manager/product-list";

    // Use a safe method to open a new tab
    const newWindow = window.open(baseUrl, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  };

  return (
    <Button
      onClick={handleOpenProductInNewTab}
      leftSection={icon}
      color="#3598dc"
      {...props}
    >
      {buttonText}
    </Button>
  );
};

export default OpenProductTab;
